// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DAJgH","loading_spinner":"styles_loading_spinner__K9OKh","spinner":"styles_spinner__0UO5g"};